import { types } from "./types/types";


const initialState = {
    identificacion: null,
    checkingIdentificacion: false,
    loadingURLAcceso: false,
}

export const auth = (state = initialState, action) => {
    switch (action.type) {
        case types.setIdentificacion:
            return {
                ...state,
                identificacion: action.payload,
                checkingIdentificacion: true
            }
        case types.startloadingSetURLAcceso:
            return {
                ...state,
                loadingURLAcceso: true,
            }
        case types.finishloadingSetURLAcceso:
            return {
                ...state,
                loadingURLAcceso: false
            }
        default:
            return state;
    }
}